import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wallet-drawer",
  role: "dialog",
  "aria-label": "Wallet"
}
const _hoisted_2 = { class: "drawer-header" }
const _hoisted_3 = { class: "balance-amount mono" }
const _hoisted_4 = {
  key: 0,
  class: "spinner"
}
const _hoisted_5 = { class: "conn-text" }
const _hoisted_6 = {
  key: 1,
  class: "boarding-status"
}
const _hoisted_7 = { class: "drawer-tabs" }
const _hoisted_8 = {
  class: "drawer-body",
  ref: "bodyEl"
}
const _hoisted_9 = {
  key: 0,
  class: "section-body"
}
const _hoisted_10 = { class: "recv-block recv-qr-block" }
const _hoisted_11 = {
  key: 1,
  class: "qr-skeleton"
}
const _hoisted_12 = { class: "qr-meta" }
const _hoisted_13 = {
  key: 0,
  class: "qr-meta-label"
}
const _hoisted_14 = {
  key: 0,
  class: "qr-meta-label"
}
const _hoisted_15 = {
  key: 1,
  class: "qr-meta-label"
}
const _hoisted_16 = {
  key: 2,
  class: "qr-meta-label hint"
}
const _hoisted_17 = ["title"]
const _hoisted_18 = {
  key: 4,
  class: "qr-meta-label hint"
}
const _hoisted_19 = { class: "qr-actions" }
const _hoisted_20 = ["href"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 2,
  class: "copy-sheet"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "copy-sheet-label" }
const _hoisted_26 = { class: "copy-sheet-value mono" }
const _hoisted_27 = {
  key: 3,
  class: "amt-form"
}
const _hoisted_28 = { class: "input-row" }
const _hoisted_29 = ["min", "max", "disabled"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "hint"
}
const _hoisted_32 = {
  key: 1,
  class: "hint"
}
const _hoisted_33 = {
  key: 4,
  class: "amt-form"
}
const _hoisted_34 = {
  key: 0,
  class: "recv-block"
}
const _hoisted_35 = { class: "recv-block" }
const _hoisted_36 = {
  key: 0,
  class: "boarding-list"
}
const _hoisted_37 = { class: "mono" }
const _hoisted_38 = { class: "text-muted boarding-conf" }
const _hoisted_39 = {
  key: 1,
  class: "info-banner"
}
const _hoisted_40 = { class: "info-text" }
const _hoisted_41 = {
  key: 2,
  class: "info-banner alt"
}
const _hoisted_42 = { class: "info-text" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 1,
  class: "section-body"
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  key: 0,
  class: "detect-row"
}
const _hoisted_48 = {
  key: 0,
  class: "hint"
}
const _hoisted_49 = {
  key: 1,
  class: "input-row"
}
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 2,
  class: "status-badge pending"
}
const _hoisted_52 = {
  key: 3,
  class: "status-badge error"
}
const _hoisted_53 = ["disabled", "title"]
const _hoisted_54 = {
  key: 4,
  class: "hint error-hint"
}
const _hoisted_55 = {
  key: 5,
  class: "hint error-hint"
}
const _hoisted_56 = {
  key: 1,
  class: "swap-result"
}
const _hoisted_57 = { class: "status-badge success" }
const _hoisted_58 = {
  key: 2,
  class: "activity-section"
}
const _hoisted_59 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_60 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_61 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_62 = {
  key: 3,
  class: "tx-list"
}
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { class: "tx-body" }
const _hoisted_66 = { class: "tx-top" }
const _hoisted_67 = { class: "tx-label" }
const _hoisted_68 = {
  key: 0,
  class: "tx-badge boarding"
}
const _hoisted_69 = {
  key: 0,
  class: "tx-detail text-muted"
}
const _hoisted_70 = { class: "tx-bottom" }
const _hoisted_71 = { class: "tx-time text-muted" }
const _hoisted_72 = ["title", "onClick"]
const _hoisted_73 = ["href"]
const _hoisted_74 = {
  key: 3,
  class: "settings-section"
}
const _hoisted_75 = ["disabled"]
const _hoisted_76 = ["disabled"]
const _hoisted_77 = { class: "server-info text-muted mono" }
const _hoisted_78 = { class: "modal-card casino-card-glow" }
const _hoisted_79 = {
  key: 0,
  class: "mnemonic-grid"
}
const _hoisted_80 = {
  key: 1,
  class: "mono"
}
const _hoisted_81 = {
  key: 1,
  class: "browser-saved-note"
}
const _hoisted_82 = { class: "modal-card casino-card-glow" }
const _hoisted_83 = { class: "modal-actions" }
const _hoisted_84 = ["disabled"]
const _hoisted_85 = { class: "modal-card casino-card-glow" }
const _hoisted_86 = {
  key: 0,
  class: "modal-desc error-hint"
}
const _hoisted_87 = {
  key: 1,
  class: "modal-desc text-muted"
}
const _hoisted_88 = {
  key: 2,
  class: "modal-desc text-muted"
}
const _hoisted_89 = {
  key: 3,
  class: "restore-list"
}
const _hoisted_90 = { class: "restore-top" }
const _hoisted_91 = { class: "restore-tier mono" }
const _hoisted_92 = { class: "restore-bottom" }
const _hoisted_93 = { class: "restore-status" }
const _hoisted_94 = { class: "restore-time text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QrCode = _resolveComponent("QrCode")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "drawer-overlay" }, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "drawer-backdrop",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "drawer" }, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
              _createElementVNode("header", _hoisted_2, [
                _createElementVNode("div", null, [
                  _cache[38] || (_cache[38] = _createElementVNode("div", { class: "balance-eyebrow" }, "YOUR BALANCE", -1)),
                  _createElementVNode("div", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_ctx.store.getters['ark/formattedBalance'] || '0') + " ", 1),
                    _cache[37] || (_cache[37] = _createElementVNode("span", { class: "balance-unit" }, "sats", -1))
                  ])
                ]),
                (_ctx.dismissible)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "close-btn",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                      "aria-label": "Close"
                    }, "×"))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "must-fund-hint",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goFund && _ctx.goFund(...args)))
                    }, "Add funds to play"))
              ]),
              (_ctx.arkStatus !== 'connected')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["conn-banner", _ctx.arkStatus])
                  }, [
                    (_ctx.arkStatus === 'connecting')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(["dot", _ctx.arkStatus])
                        }, null, 2)),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.connText), 1),
                    (_ctx.arkStatus === 'error' || _ctx.arkStatus === 'disconnected')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "btn-outline btn-xs",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reconnect && _ctx.reconnect(...args)))
                        }, " Retry "))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.boardingBalance > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _cache[39] || (_cache[39] = _createElementVNode("span", { class: "boarding-dot" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.boardingBalance.toLocaleString()) + " sats boarding ", 1),
                    _cache[40] || (_cache[40] = _createElementVNode("span", { class: "text-muted" }, "— settling into Ark", -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: _normalizeClass(['tab', { active: _ctx.tab === 'receive' }]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tab = 'receive'))
                }, "Receive", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(['tab', { active: _ctx.tab === 'send' }]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tab = 'send'))
                }, "Send", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(['tab', { active: _ctx.tab === 'activity' }]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.tab = 'activity'))
                }, "Activity", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(['tab', { active: _ctx.tab === 'settings' }]),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.tab = 'settings'))
                }, "Settings", 2)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.tab === 'receive')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.qrValue)
                          ? (_openBlock(), _createBlock(_component_QrCode, {
                              key: 0,
                              value: _ctx.qrValue,
                              size: 244,
                              onCopy: _cache[8] || (_cache[8] = ($event: any) => (_ctx.copyText(_ctx.qrValue))),
                              title: "Tap to copy"
                            }, null, 8, ["value"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.ready ? 'Generating…' : 'Connecting…'), 1)),
                        _createElementVNode("div", _hoisted_12, [
                          (_ctx.selectedPayload && _ctx.selectedPayloadId !== 'unified')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createTextVNode(_toDisplayString(_ctx.selectedPayload.label) + " ", 1),
                                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "hint" }, "· raw value", -1))
                              ]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_ctx.depositInvoice)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Lightning invoice (" + _toDisplayString(Number(_ctx.depositAmount).toLocaleString()) + " sats)", 1))
                                  : (_ctx.lnurlStatus === 'open')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Pay any amount · on-chain + Ark + Lightning"))
                                    : (_ctx.lnurlStatus === 'opening')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Connecting to LNURL server…"))
                                      : (_ctx.lnurlStatus === 'error')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 3,
                                            class: "qr-meta-label hint error-hint",
                                            title: _ctx.lnurlError || ''
                                          }, " Lightning receive unavailable (server error) ", 8, _hoisted_17))
                                        : (_ctx.lnurlStatus === 'disabled')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Lightning receive unavailable (no LNURL server configured)"))
                                          : _createCommentVNode("", true)
                              ], 64))
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          (_ctx.qrIsUri)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "btn-outline btn-sm",
                                href: _ctx.qrValue
                              }, "Open in wallet", 8, _hoisted_20))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "btn-outline btn-sm",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.copySheetOpen = !_ctx.copySheetOpen)),
                            disabled: !_ctx.copyOptions.length
                          }, " Payment method ⌄ ", 8, _hoisted_21),
                          (!_ctx.depositInvoice)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn-outline btn-sm",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showAmountForm = !_ctx.showAmountForm)),
                                disabled: !_ctx.ready
                              }, _toDisplayString(_ctx.showAmountForm ? 'Hide' : 'Add amount (LN invoice)'), 9, _hoisted_22))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.copySheetOpen)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.copyOptions, (opt) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: opt.id,
                                  class: _normalizeClass(["copy-sheet-item", { active: opt.id === _ctx.selectedPayloadId }]),
                                  onClick: ($event: any) => (_ctx.selectPayload(opt))
                                }, [
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(opt.label), 1),
                                  _createElementVNode("span", _hoisted_26, _toDisplayString(opt.value.length > 36 ? opt.value.slice(0, 18) + '…' + opt.value.slice(-12) : opt.value), 1)
                                ], 10, _hoisted_24))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.showAmountForm && !_ctx.depositInvoice)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "input",
                                  type: "number",
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.depositAmount) = $event)),
                                  placeholder: "Amount in sats",
                                  min: _ctx.limits?.min,
                                  max: _ctx.limits?.max,
                                  disabled: !_ctx.ready
                                }, null, 8, _hoisted_29), [
                                  [
                                    _vModelText,
                                    _ctx.depositAmount,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                _createElementVNode("button", {
                                  class: "btn-primary btn-sm",
                                  disabled: !_ctx.depositAmount || _ctx.depositLoading || !_ctx.ready,
                                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.createLnDeposit && _ctx.createLnDeposit(...args)))
                                }, _toDisplayString(_ctx.depositLoading ? 'Creating…' : 'Invoice'), 9, _hoisted_30)
                              ]),
                              (_ctx.depositAmount && _ctx.fees)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _cache[42] || (_cache[42] = _createTextVNode(" You receive ≈ ", -1)),
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.calcReceive(_ctx.depositAmount).toLocaleString()), 1),
                                    _cache[43] || (_cache[43] = _createTextVNode(" sats after fees ", -1))
                                  ]))
                                : (_ctx.fees && _ctx.limits)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.limits.min.toLocaleString()) + " – " + _toDisplayString(_ctx.limits.max.toLocaleString()) + " sats · " + _toDisplayString(_ctx.fees.reverse.percentage) + "% + " + _toDisplayString((_ctx.fees.reverse.minerFees.lockup + _ctx.fees.reverse.minerFees.claim).toLocaleString()) + " fee ", 1))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.depositInvoice)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["status-badge", _ctx.depositStatus])
                              }, _toDisplayString(_ctx.depositStatusText), 3),
                              _createElementVNode("button", {
                                class: "btn-outline btn-sm",
                                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.resetDeposit && _ctx.resetDeposit(...args)))
                              }, "New invoice")
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.isMutinyTestnet && _ctx.ready)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("button", {
                              class: "btn-outline btn-sm",
                              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.requestFaucet && _ctx.requestFaucet(...args)))
                            }, "Request Testnet Faucet")
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_35, [
                        _cache[47] || (_cache[47] = _createElementVNode("div", { class: "block-label" }, "On-chain status", -1)),
                        (_ctx.boardingUtxos.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boardingUtxos, (utxo) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: utxo.outpoint.txid + ':' + utxo.outpoint.vout,
                                  class: "boarding-item"
                                }, [
                                  _cache[44] || (_cache[44] = _createElementVNode("span", { class: "boarding-dot" }, null, -1)),
                                  _createElementVNode("span", _hoisted_37, _toDisplayString(Number(utxo.amount).toLocaleString()) + " sats", 1),
                                  _createElementVNode("span", _hoisted_38, _toDisplayString(utxo.confirmations ? utxo.confirmations + ' conf' : 'unconfirmed'), 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.hasUnconfirmedBoarding)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _cache[45] || (_cache[45] = _createElementVNode("span", { class: "info-icon" }, "⏳", -1)),
                              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.unconfirmedBoardingAmount.toLocaleString()) + " sats deposited on-chain — waiting for confirmation before they can be settled into Ark. ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.hasRecoverable)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _cache[46] || (_cache[46] = _createElementVNode("span", { class: "info-icon" }, "↺", -1)),
                              _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.recoverableAmount.toLocaleString()) + " sats recoverable from prior sub-dust outputs or expired sweeps — settle to reclaim them. ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.hasUnsettledFunds && _ctx.ready)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              class: "btn-primary btn-sm",
                              disabled: _ctx.settleLoading,
                              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.settleFunds && _ctx.settleFunds(...args)))
                            }, _toDisplayString(_ctx.settleLoading ? 'Settling…' : _ctx.settleReasonLabel), 9, _hoisted_43))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === 'send')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_44, [
                      (_ctx.sendStatus !== 'success')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _withDirectives(_createElementVNode("textarea", {
                              class: "input send-input",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.sendInput) = $event)),
                              rows: "2",
                              disabled: !_ctx.ready,
                              placeholder: "Paste a Lightning invoice / address, LNURL, Ark address, or Bitcoin address"
                            }, null, 8, _hoisted_46), [
                              [_vModelText, _ctx.sendInput]
                            ]),
                            (_ctx.sendInput.trim())
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["detect-chip", _ctx.sendDetected.kind])
                                  }, _toDisplayString(_ctx.sendKindLabel), 3),
                                  (_ctx.sendDetected.kind === 'lightning' && _ctx.sendDetected.amountSats > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.sendDetected.amountSats.toLocaleString()) + " sats ", 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.sendNeedsAmount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "input",
                                    type: "number",
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.sendAmount) = $event)),
                                    placeholder: "Amount (sats)",
                                    min: "0",
                                    disabled: !_ctx.ready
                                  }, null, 8, _hoisted_50), [
                                    [
                                      _vModelText,
                                      _ctx.sendAmount,
                                      void 0,
                                      { number: true }
                                    ]
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn-outline btn-sm",
                                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.sendSetMax && _ctx.sendSetMax(...args)))
                                  }, "MAX")
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.sendStatus === 'pending')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_ctx.sendStatusText), 1))
                              : (_ctx.sendStatus === 'error')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.sendStatusText), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              class: "btn-primary",
                              disabled: !_ctx.canSend,
                              title: !_ctx.ready ? 'Connecting to Ark…' : '',
                              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.doSend && _ctx.doSend(...args)))
                            }, _toDisplayString(_ctx.sendLoading ? 'Sending…' : _ctx.sendButtonLabel), 9, _hoisted_53),
                            (_ctx.sendInput.trim() && _ctx.sendDetected.kind === 'unknown')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_54, " Unrecognized destination — paste a Lightning invoice/address, LNURL, Ark, or Bitcoin address. "))
                              : (_ctx.sendDetected.kind === 'lightning' && _ctx.sendDetected.amountSats === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, " Amountless invoices aren't supported — use one with a fixed amount. "))
                                : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.sendStatusText), 1),
                            _createElementVNode("button", {
                              class: "btn-outline btn-sm",
                              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.resetSend && _ctx.resetSend(...args)))
                            }, "New Payment")
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === 'activity')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_58, [
                      (_ctx.activityStatus === 'loading' && _ctx.activityHistory.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [...(_cache[48] || (_cache[48] = [
                            _createElementVNode("div", { class: "spinner" }, null, -1),
                            _createElementVNode("div", { class: "empty-text" }, "Loading activity…", -1)
                          ]))]))
                        : (_ctx.activityStatus === 'error' && _ctx.activityHistory.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _cache[49] || (_cache[49] = _createElementVNode("div", { class: "empty-icon" }, "⚠", -1)),
                              _cache[50] || (_cache[50] = _createElementVNode("div", { class: "empty-text" }, "Couldn't load activity", -1)),
                              _cache[51] || (_cache[51] = _createElementVNode("div", { class: "hint" }, "The wallet history didn't load. Check your connection and try again.", -1)),
                              _createElementVNode("button", {
                                class: "btn-outline",
                                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.retryActivity && _ctx.retryActivity(...args)))
                              }, "Retry")
                            ]))
                          : (_ctx.activityHistory.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [...(_cache[52] || (_cache[52] = [
                                _createElementVNode("div", { class: "empty-icon" }, "☀", -1),
                                _createElementVNode("div", { class: "empty-text" }, "No activity yet", -1),
                                _createElementVNode("div", { class: "hint" }, "Your wallet activity will appear here", -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityHistory, (act) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: act.id,
                                    class: "tx-row"
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["tx-dir", act.amount >= 0 ? 'received' : 'sent'])
                                    }, [
                                      (act.amount >= 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_63, "▼"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_64, "▲"))
                                    ], 2),
                                    _createElementVNode("div", _hoisted_65, [
                                      _createElementVNode("div", _hoisted_66, [
                                        _createElementVNode("span", _hoisted_67, [
                                          _createTextVNode(_toDisplayString(act.intent?.label || (act.amount >= 0 ? 'Received' : 'Sent')) + " ", 1),
                                          (act.intent?.kind === 'boarding')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_68, "Boarding"))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["tx-amount", act.amount >= 0 ? 'received' : 'sent'])
                                        }, [
                                          _createTextVNode(_toDisplayString(act.amount >= 0 ? '+' : '−') + _toDisplayString(Math.abs(act.amount).toLocaleString()) + " ", 1),
                                          _cache[53] || (_cache[53] = _createElementVNode("span", { class: "tx-unit" }, "sats", -1))
                                        ], 2)
                                      ]),
                                      (_ctx.detailOf(act))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_ctx.detailOf(act)), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_70, [
                                        _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.formatRelative(act.createdAt)), 1),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["tx-status", act.settled ? 'settled' : 'pending'])
                                        }, _toDisplayString(act.settled ? 'Settled' : 'Pending'), 3)
                                      ]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(act.txs, (t, i) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: `${i}:${_ctx.txidOf(t)}`,
                                          class: "tx-id-row"
                                        }, [
                                          _createElementVNode("span", {
                                            class: "tx-id mono",
                                            title: _ctx.txidOf(t),
                                            onClick: ($event: any) => (_ctx.copyText(_ctx.txidOf(t)))
                                          }, _toDisplayString(_ctx.txidOf(t).slice(0, 12)) + "…" + _toDisplayString(_ctx.txidOf(t).slice(-8)), 9, _hoisted_72),
                                          (_ctx.explorerUrlFor(_ctx.txidOf(t)))
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                class: "tx-explorer",
                                                href: _ctx.explorerUrlFor(_ctx.txidOf(t)),
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                title: "Open in the Arkade explorer"
                                              }, "↗", 8, _hoisted_73))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                }), 128))
                              ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === 'settings')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_74, [
                      _createElementVNode("button", {
                        class: "btn-outline",
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showKey = true))
                      }, "Back Up Wallet"),
                      _createElementVNode("button", {
                        class: "btn-outline",
                        disabled: _ctx.resyncing,
                        onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.resyncWallet && _ctx.resyncWallet(...args)))
                      }, _toDisplayString(_ctx.resyncing ? 'Resyncing…' : 'Resync Wallet Data'), 9, _hoisted_75),
                      _cache[55] || (_cache[55] = _createElementVNode("p", { class: "text-muted mono resync-hint" }, "Clears cached balance/VTXOs and re-syncs from the server. Keeps your key — use after a node/chain reset.", -1)),
                      _createElementVNode("button", {
                        class: "btn-outline",
                        disabled: _ctx.restoring,
                        onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.restoreGames && _ctx.restoreGames(...args)))
                      }, _toDisplayString(_ctx.restoring ? 'Restoring…' : 'Restore Games from Server'), 9, _hoisted_76),
                      _cache[56] || (_cache[56] = _createElementVNode("p", { class: "text-muted mono resync-hint" }, "Fetches your game history from the server, signed with your wallet key. Stalled games recover automatically.", -1)),
                      _createElementVNode("button", {
                        class: "btn-outline",
                        onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.copyDiagnostics && _ctx.copyDiagnostics(...args)))
                      }, "Copy Diagnostics"),
                      _cache[57] || (_cache[57] = _createElementVNode("p", { class: "text-muted mono resync-hint" }, "Copies recent errors + app/network info to your clipboard, so you can paste them when reporting a problem. No keys or funds are included.", -1)),
                      _createElementVNode("button", {
                        class: "btn-danger",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showDeleteConfirm = true))
                      }, "Delete Wallet"),
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", null, [
                          _createTextVNode("Network: " + _toDisplayString(_ctx.info?.network || '—') + " ", 1),
                          _cache[54] || (_cache[54] = _createElementVNode("span", { class: "net-note" }, "(set by server)", -1))
                        ]),
                        _createElementVNode("div", null, "Ark: " + _toDisplayString(_ctx.arkServer), 1),
                        _createElementVNode("div", null, "Status: " + _toDisplayString(_ctx.arkStatus), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 512),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.showKey)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "overlay",
                        onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (_ctx.showKey = false), ["self"]))
                      }, [
                        _createElementVNode("div", _hoisted_78, [
                          _cache[59] || (_cache[59] = _createElementVNode("h3", { class: "modal-title text-gold" }, "Wallet Backup", -1)),
                          _cache[60] || (_cache[60] = _createElementVNode("p", { class: "modal-desc text-muted" }, "Your recovery phrase (or legacy key). Save it securely; never share it.", -1)),
                          _createElementVNode("div", {
                            class: "key-display",
                            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.copyText(_ctx.privateKey)))
                          }, [
                            (_ctx.phraseWords.length)
                              ? (_openBlock(), _createElementBlock("ol", _hoisted_79, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phraseWords, (word, i) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: i,
                                      class: "mnemonic-word"
                                    }, _toDisplayString(word), 1))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("code", _hoisted_80, _toDisplayString(_ctx.privateKey), 1)),
                            _cache[58] || (_cache[58] = _createElementVNode("span", { class: "address-action" }, "Click to copy", -1))
                          ]),
                          (_ctx.credentialBackupSupported && !_ctx.savedToBrowser)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn-outline",
                                onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.saveToBrowser && _ctx.saveToBrowser(...args)))
                              }, " Also save to browser "))
                            : (_ctx.savedToBrowser)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_81, "✓ Sent to your browser — check your saved passwords to confirm"))
                              : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "btn-outline",
                            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showKey = false))
                          }, "Close")
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.showDeleteConfirm)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "overlay",
                        onClick: _cache[34] || (_cache[34] = _withModifiers(($event: any) => (_ctx.showDeleteConfirm = false), ["self"]))
                      }, [
                        _createElementVNode("div", _hoisted_82, [
                          _cache[61] || (_cache[61] = _createElementVNode("h3", { class: "modal-title text-red" }, "Delete Wallet", -1)),
                          _cache[62] || (_cache[62] = _createElementVNode("p", { class: "modal-desc text-muted" }, "This cannot be undone. Type DELETE to confirm.", -1)),
                          _withDirectives(_createElementVNode("input", {
                            class: "input",
                            type: "text",
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.deleteConfirmText) = $event)),
                            placeholder: "DELETE"
                          }, null, 512), [
                            [_vModelText, _ctx.deleteConfirmText]
                          ]),
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("button", {
                              class: "btn-outline",
                              onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.showDeleteConfirm = false))
                            }, "Cancel"),
                            _createElementVNode("button", {
                              class: "btn-danger",
                              disabled: _ctx.deleteConfirmText !== 'DELETE',
                              onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.deleteWallet && _ctx.deleteWallet(...args)))
                            }, "Delete", 8, _hoisted_84)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.showRestore)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "overlay",
                        onClick: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (_ctx.showRestore = false), ["self"]))
                      }, [
                        _createElementVNode("div", _hoisted_85, [
                          _cache[64] || (_cache[64] = _createElementVNode("h3", { class: "modal-title text-gold" }, "Restored Games", -1)),
                          (_ctx.restoreError)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString(_ctx.restoreError), 1))
                            : (_ctx.restoredGames.length === 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_87, "No games found for this wallet."))
                              : (_openBlock(), _createElementBlock("p", _hoisted_88, _toDisplayString(_ctx.restoredGames.length) + " game" + _toDisplayString(_ctx.restoredGames.length === 1 ? '' : 's') + " found. ", 1)),
                          (_ctx.restoredGames.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restoredGames, (g) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: g.gameId,
                                    class: "restore-row"
                                  }, [
                                    _createElementVNode("div", _hoisted_90, [
                                      _createElementVNode("span", _hoisted_91, [
                                        _createTextVNode(_toDisplayString(g.tier.toLocaleString()) + " ", 1),
                                        _cache[63] || (_cache[63] = _createElementVNode("span", { class: "restore-unit" }, "sats", -1))
                                      ]),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["restore-outcome", _ctx.outcomeClass(g)])
                                      }, _toDisplayString(_ctx.outcomeLabel(g)), 3)
                                    ]),
                                    _createElementVNode("div", _hoisted_92, [
                                      _createElementVNode("span", _hoisted_93, _toDisplayString(g.status), 1),
                                      _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.formatRestoreDate(g.createdAt)), 1)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "btn-outline",
                            onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.showRestore = false))
                          }, "Close")
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "toast" }, {
                default: _withCtx(() => [
                  (_ctx.toastMsg)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["toast", _ctx.toastType])
                      }, _toDisplayString(_ctx.toastMsg), 3))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}